export enum ClassificationUploadType {
  ClassifiedUpload = 'ClassifiedUpload',
  UnclassifiedUpload = 'UnclassifiedUpload',
}
